var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLikeFilled = function SvgIconLikeFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M12.938 21.545a1.41 1.41 0 0 1-1.874-.003l-.79-.707C4.146 15.37.1 11.762.1 7.338.1 3.733 2.98.9 6.645.9c2.07 0 4.058.948 5.355 2.446A7.18 7.18 0 0 1 17.355.9C21.02.9 23.9 3.733 23.9 7.338c0 4.424-4.046 8.03-10.175 13.508z",
    clipRule: "evenodd"
  })));
};
export default SvgIconLikeFilled;